import * as React from "react";

const SvgPreviousFilled = props => <svg data-name="Layer 1" viewBox="0 0 40 40" width="1em" height="1em" {...props}><circle cx={20} cy={20} r={20} style={{
    fill: "#636363"
  }} /><path d="m25 20-4 4 4 4" transform="translate(-4 -4)" style={{
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }} /></svg>;

export default SvgPreviousFilled;